
import axios from "axios";
import { URL_BASE } from "../config/url-server";

const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")

export const getPalm = async (palmId) => {
    const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
    try {
      const response = await axios.get(URL_BASE+"palm/get/"+palmId, config)
      const palm = response.data?.data || null;
      return palm;
    } catch (error) {
      console.error("Error :", error);
      return null;
    }
  };

  

export const getList = async () => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.get(URL_BASE+"palm/list", config);
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};



export const getListByLine= async (lineId) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.get(URL_BASE+"palm/list-by-line/"+lineId, config);
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};



export const insert = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"palm/insert", data, config)
    const success = response.data?.success || false;
    return success;
  } catch (error) {
    console.error("Error :", error);
    return false;
  }
};



export const update = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"palm/update", data, config)
    const responseData = response.data;
    return responseData;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};




export const deletePalm = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"palm/delete", data, config)
    const responseData = response.data;
    return responseData;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};




  export default{
    getPalm,
    getList,
    insert,
    getListByLine,
    update,
    deletePalm
  }

